module.exports = __webpack_public_path__ + "glockenklang.hash_1e6ac0ad4ba9102ab561b296e6349ef8.ogg";